import { leadershipImgs, s3Bucket } from ".";

export const marketingArr = () => [
    {
        name: "Daniel Melling",
        img: leadershipImgs.daniel,
        title: "Director of Marketing and Communications",
    },
    {
        name: "Janet Smith",
        img: leadershipImgs.janet,
        title: "Director of Development",
    },
    {
        name: "Raymond Song",
        img: leadershipImgs.ray,
        title: "Carbon Markets and Policy Lead",
    },
    {
        name: "Rachel Kovinsky",
        img: `${s3Bucket}rkovinsky.png`,
        title: "Communications Manager",
    },
    {
        name: "Aijing Li",
        img: `${s3Bucket}ali.jpg`,
        title: "Research and Engagement Specialist",
    },
];